const styles = theme => ({
  paper: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: 8,
    boxShadow: 'none!important'
  }),
  graph:{
    marginBottom: 40
  }
})

export default styles
